export default __webpack_public_path__ + "static/sam42_hr-e7d7de111f723e4e16baa8a61d803489.jpg";